import currencyFormat from "currency.js";

export const unitFormat = (valor) => {
  return currencyFormat(valor, {
    separator: ".",
    precision: 0,
  }).format();
};
